





























































































































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import NumberTmpl from "@/ui-component/number.vue";
import LineTicketAudit from "./LineTicketAudit.vue";

@Component({
  components: {
    NumberTmpl,
    LineTicketAudit,
  },
})
export default class TicketAudit extends mixins(MyMixin) {
  @Prop() public ticketData!: any;
  public ticketAudit: any = {};
  public dataGetted = false;

  public mounted() {
    this.dataGetted = false;
    if (this.ticketData) {
      this.decodeTicket();
    }
  }
  /**
   * methode de transformation du format recu en format plus facilement a interpreter coté affichage
   */
  private decodeTicket() {
    console.log(this.ticketData);
    this.ticketAudit.restaurantId = this.ticketData.restaurantId;
    this.ticketAudit.numTicket = this.ticketData.numTicket;
    this.ticketAudit.horodatage = this.formatDateTicketHour(
      this.ticketData.age
    );
    this.ticketAudit.managerName = this.ticketData.managerName;
    this.ticketAudit.managerCode = this.ticketData.managerCode;
    this.ticketAudit.nbCouverts = this.ticketData.nbCouverts;
    this.ticketAudit.vendeurName = this.ticketData.libVendeur;
    this.ticketAudit.vendeurCode = this.ticketData.numVendeur;
    this.ticketAudit.montant = {
      ht: this.ticketData.montantHt,
      ttc: this.ticketData.montantTtc,
      tva: this.ticketData.montantTva,
    };
    this.ticketAudit.profit = this.ticketData.profit;
    this.ticketAudit.localisation = this.ticketData.localisation;
    this.ticketAudit.libSite = this.ticketData.libSite;
    this.ticketAudit.service = this.ticketData.service;
    this.ticketAudit.remises = this.ticketData.remises;
    this.ticketAudit.estAnnulation = this.ticketData.ticketAnnulation !== null;

    this.ticketAudit.estAnnule = this.ticketData.ticketAnnule !== null;

    this.ticketAudit.statistiques = new Array();
    this.ticketData.statistiquess.map((stat: any) => {
      if (stat.libelle.includes("CREATION COMMANDE")) {
        this.ticketAudit.heureDebut = this.formatDateTicketHour(
          stat.horodatage
        );
      } else if (stat.numero === 17) {
        this.ticketAudit.estTransfert = true;
      }
      const statistique = {
        libelle: stat.libelle,
        vendeur: stat.libVendeur,
        numero: stat.numero,
        profit: stat.profit,
        horodatage: this.formatTicketHour(stat.horodatage),
      };
      this.ticketAudit.statistiques.push(statistique);
    });

    this.ticketData.complements.map((cmpl: any) => {
      if (cmpl.cle.includes("SALLE")) {
        this.ticketAudit.salle = cmpl.valeur;
      }
      if (cmpl.cle.includes("TABLE")) {
        this.ticketAudit.table = cmpl.valeur;
      }
      if (cmpl.cle.includes("nomVendeurRemunere")) {
        this.ticketAudit.vendeurRemunere = cmpl.valeur;
      }
      if (cmpl.cle.includes("codeVendeurRemunere")) {
        this.ticketAudit.vendeurRemunereCode = cmpl.valeur;
      }
    });
    this.ticketAudit.suppressions = new Array();
    this.ticketAudit.commandes = new Array();

    this.ticketData.commandes.map((comm: any) => {
      let accompagnements = comm.articles.filter((article: any) => {
        return article.parentLineUuid !== null;
      });
      accompagnements = accompagnements.map((acc: any) =>
        this.clearArticle(acc)
      );

      const articles = comm.articles.filter((article: any) => {
        return article.parentLineUuid === null;
      });
      const artofferts = comm.articles.filter((article: any) => {
        return article.offerts.length > 0;
      });

      let offerts = new Array();
      artofferts.map((off: any) => {
        offerts = offerts.concat(off.offerts);
      });
      this.ticketAudit.offerts = offerts;
      console.log(offerts);

      accompagnements.map((acc: any) => {
        const accs = accompagnements.filter(
          (accomp: any) => accomp.parentLineUuid === acc.id
        );
        acc.accompagnements = accs;
        return acc;
      });

      articles.map((article: any) => {
        const accs = accompagnements.filter(
          (acc: any) => acc.parentLineUuid === article.id
        );
        article.accompagnements = accs;
        return article;
      });

      const commande = {
        id: comm.id,
        articles: new Array(),
        suppressions: new Array(),
        canceled: comm.canceled,
        horodatage: this.formatTicketHour(comm.horodatage),
        majorations: comm.majorations,
        remises: comm.remises,
        commentaires: comm.commentaires,
        commentairelibres: comm.commentairelibres,
      };

      comm.suppressions.map((supp: any) => {
        // console.log(supp);
        const art = this.clearArticle(supp);
        commande.suppressions.push(art);
      });
      this.decodeSuppressions(commande.suppressions);

      articles.map((article: any) => {
        const art = this.clearArticle(article);
        commande.articles.push(art);
      });

      this.ticketAudit.commandes.push(commande);
    });

    this.ticketAudit.reglements = new Array();
    this.ticketData.reglements.map((reglement: any) => {
      const regl = {
        id: reglement.id,
        famille: reglement.LibFamille,
        libelle: reglement.Libelle,
        qte: reglement.quantite,
        montantUnitaire: reglement.valeurUnitaire,
        montantTotal: reglement.totalValue,
        horodatage: reglement.horodatage,
        libVendeur: reglement.libVendeur,
        numVendeur: reglement.numVendeur,
        libCaisse: reglement.libCaisse,
        valeur: reglement.totalValue,
      };
      this.ticketAudit.reglements.push(regl);
    });
    this.calculate();

    // console.log(this.ticketAudit);
    this.dataGetted = true;
    this.$forceUpdate();
  }

  private calculate() {
    let sommeSuppressions = 0;
    this.ticketAudit.suppressions.map(
      (supp: any) => (sommeSuppressions += supp.prixUnitaireTTC)
    );
    this.ticketAudit.sommeSuppressions = sommeSuppressions;

    let sommeRemises = 0;
    this.ticketAudit.remises.map((supp: any) => (sommeRemises += supp.valeur));
    this.ticketAudit.sommeRemises = sommeRemises;

    let sommeOfferts = 0;
    this.ticketAudit.offerts.map((supp: any) => (sommeOfferts += supp.valeur));
    this.ticketAudit.sommeOfferts = sommeOfferts;
  }
  /**
   * methode de decryptage des suppressions en accompagnement / article
   */
  private decodeSuppressions(suppressions: any[]) {
    const supAcc = suppressions.filter(
      (supp: any) => supp.parentLineUuid !== null
    );
    const suppArt = suppressions.filter(
      (supp: any) => supp.parentLineUuid === null
    );

    suppArt.map((article: any) => {
      const accs = supAcc.filter(
        (acc: any) => acc.parentLineUuid === article.id
      );
      article.accompagnements = accs;
      return article;
    });
    // console.log(suppArt);
    this.ticketAudit.suppressions =
      this.ticketAudit.suppressions.concat(suppArt);
  }
  /**
   * methode permettant de nettoyer l'article des champs inutiles
   */
  private clearArticle(article: any) {
    return {
      libelle: article.libelle,
      libFamille: article.libFamille,
      annulations: article.annulations,
      horodatage: article.horodatage,
      encaisse: article.encaisse,
      estAnnule: article.estAnnule,
      estMajore: article.estMajore,
      estOffert: article.estOffert,
      estRemise: article.estRemise,
      libGroupe: article.libGroupe,
      libCaisse: article.libCaisse,
      tag: article.tag,
      reference: article.reference,
      remises: article.remise,
      quantite: article.quantite,
      numero: article.numero,
      prixTotalNet: article.prixTotalNet,
      prixTotalNetHT: article.prixTotalNetHT,
      prixTotalNetRemiseEtMajore: article.prixTotalNetRemiseEtMajore,
      prixUnitaireTTC: article.prixUnitaireTTC,
      offerts: article.offerts,
      parentLineUuid: article.parentLineUuid,
      id: article.id,
      libelleQualifier: article.libelleQualifier,

      discountOnLineAmount: article.discountOnLineAmount,
      discountOnLineId: article.discountOnLineId,
      discountOnLineName: article.discountOnLineName,
      discountOnStotalAmount: article.discountOnStotalAmount,
      discountOnStotalId: article.discountOnStotalId,
      discountOnStotalName: article.discountOnStotalName,
      discountOnTotalId: article.discountOnTotalId,
      discountOnTotalName: article.discountOnTotalName,

      majorations: article.majorations,
      accompagnements: article.accompagnements,
      libVendeur: article.libVendeur,
      numVendeur: article.numVendeur,
      numManager: article.managerCode,
      libManager: article.managerName,
    };
  }
}
